module.exports = __webpack_public_path__ + "static/media/video-beenfo.a62238c9.mp4";